import { render, staticRenderFns } from "./ModalProspectedCoach.vue?vue&type=template&id=26b1d9ef"
import script from "./ModalProspectedCoach.vue?vue&type=script&lang=js"
export * from "./ModalProspectedCoach.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports